import React, { useState } from "react";

const AddCandidatesTab = ({
  candidates,
  onAddCandidate,
  onDeleteCandidate,
}) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    company: "",
    userType: "jobseeker",
  });
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);

  // Find selected candidate for userType & id retrieval
  const selectedCandidate = candidates.find((c) => c.id === selectedCandidateId);

  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.password.trim()) {
      setError("Name, Email and Password are required.");
      return;
    }
    onAddCandidate(form);
    setForm({ name: "", email: "", password: "", company: "", userType: "jobseeker" });
  };

  return (
    <div className="bg-white shadow-sm border rounded-lg overflow-hidden">
      {/* Form to add candidates */}
      <form onSubmit={handleSubmit} className="p-6 border-b border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          <input
            className="border border-gray-300 rounded-md shadow-sm px-3 py-2 text-sm text-gray-900"
            type="text"
            name="name"
            placeholder="Name"
            value={form.name}
            onChange={handleChange}
          />
          <input
            className="border border-gray-300 rounded-md shadow-sm px-3 py-2 text-sm text-gray-900"
            type="email"
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
          />
          <input
            className="border border-gray-300 rounded-md shadow-sm px-3 py-2 text-sm text-gray-900"
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
          />
          <input
            className="border border-gray-300 rounded-md shadow-sm px-3 py-2 text-sm text-gray-900"
            type="text"
            name="company"
            placeholder="Company (optional)"
            value={form.company}
            onChange={handleChange}
          />
          <select
            className="border border-gray-300 rounded-md shadow-sm px-3 py-2 text-sm text-gray-900"
            name="userType"
            value={form.userType}
            onChange={handleChange}
          >
            <option value="jobseeker">Jobseeker</option>
            <option value="HR">HR</option>
          </select>
        </div>
        {error && <div className="text-red-600 text-sm mt-2">{error}</div>}
        <button
          type="submit"
          className="mt-4 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 font-semibold"
        >
          Add Candidate
        </button>
      </form>

        {/* Candidates table with selection */}
      <div className="overflow-x-auto mt-6">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3"></th> {/* For selection radio */}
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Company</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">User Type</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {candidates.length === 0 ? (
              <tr>
                <td colSpan={5} className="px-6 py-8 text-center text-gray-500">
                  <p className="text-lg font-medium">No candidates found</p>
                  <p className="text-sm">Add candidates using the form above</p>
                </td>
              </tr>
            )  :(
              candidates.map((cand) => (
                <tr
                  key={cand.id}
                  className={`hover:bg-gray-50 ${selectedCandidateId === cand.id ? "bg-blue-100" : ""}`}
                >
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    <input
                      type="radio"
                      name="selectedCandidate"
                      checked={selectedCandidateId === cand.id}
                      onChange={() => setSelectedCandidateId(cand.id)}
                    />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{cand.name}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{cand.email}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{cand.company || ""}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{cand.userType}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {/* Centralized delete button */}
      <div className="mt-4">
        <button
          disabled={!selectedCandidateId}
          onClick={() => {
            if (selectedCandidate && onDeleteCandidate) {
              onDeleteCandidate(selectedCandidate.id, selectedCandidate.userType);
              setSelectedCandidateId(null); // reset selection
            }
          }}
          className={`px-4 py-2 rounded font-semibold text-white ${
            selectedCandidateId ? "bg-red-600 hover:bg-red-700" : "bg-gray-300 cursor-not-allowed"
          }`}
        >
          Delete Selected Candidate
        </button>
      </div>
    </div>
  );
};

export default AddCandidatesTab;
